export default __webpack_public_path__ + "media/src/assets/images/Commercial-28f83de07854d0720bae2d425013f20c.svg";